import React from "react";
import { AuthShell } from "./auth-ui";
import { AccessNotAvailableFormView } from "./auth-ui/AuthFormViews";

export const AccessNotAvailable: React.FC = () => {
    const handleBackToDashboard = () => {
        window.location.href = process.env.REACT_APP_TREEZ_LOGIN_URL ?? "";
    };

    return (
        <AuthShell title="Ecommerce Access Not Available">
            <AccessNotAvailableFormView
                onBackToDashboard={handleBackToDashboard}
            />
        </AuthShell>
    );
};
